export class AbstractHandler {
    /**
     * @param {string} url
     * @param {string} title
     * @param {string} selector
     */
    // eslint-disable-next-line no-unused-vars
    mount(url, title, selector) {
        throw new Error("Метод не реализован.");
    }
}
